import axios from "axios";

export const axiosInstance = axios.create({
  baseURL: "https://businessinstagram.kpop21.com/",
});

export const baseURL = "https://businessinstagram.kpop21.com/";
